import { render, staticRenderFns } from "./ResidentsCorner.vue?vue&type=template&id=56699382&scoped=true"
import script from "./ResidentsCorner.vue?vue&type=script&lang=js"
export * from "./ResidentsCorner.vue?vue&type=script&lang=js"
import style0 from "./ResidentsCorner.vue?vue&type=style&index=0&id=56699382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56699382",
  null
  
)

export default component.exports